<template>
  <div v-show="is_show_filter_preiod" class="works-filter__block works-filter__block-period">
    <div class="works-filter__block-item">
      <div class="works-filter__block-title">{{ $t("message.Period") }}</div>
    </div>

    <div class="slider__list-container">
      <div class="dropdown-list__wrapper" style="overflow: visible">
        <div class="range-slider c_ui7" ref="period_range"></div>
        <div class="range-slider__nav">
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">&nbsp;</div>
            </div>
          </div>
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">{{ cur_from }}</div>
            </div>
          </div>
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">{{ cur_to }}</div>
            </div>
          </div>
          <div class="range-slider__scale">
            <div class="range-slider__scale-point">
              <div class="range-slider__scale-item">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- нужно, чтобы updated срабатывал, там мы устанавливаем новые границы для слайдера -->
    <!-- костыльное решение -->
    <div style="display: none">
      =={{ min_from }}, {{ max_to }}==
    </div>

    <div v-if="min_from<period_min" class="item-line"><label :class="label_class"><span class="checkbox"><input type="checkbox" name="" v-model="less1950" @change="periodChange('less1950')"><span class="check"></span></span> {{ label_less1950 }}</label></div>
    <div class="item-line"><label :class="label_class"><span class="checkbox"><input type="checkbox" name="" v-model="from1950to1990" @change="periodChange('from1950to1990')"><span class="check"></span></span> {{ label_from1950to1990 }}</label></div>
    <div v-if="max_to>period_max" class="item-line"><label :class="label_class"><span class="checkbox"><input type="checkbox" name="" v-model="more1990" @change="periodChange('more1990')"><span class="check"></span></span> {{ label_more1990 }}</label></div>
  </div>
</template>


<script>
  import FilterPeriodMix from "../../../../../components/list/filter/FilterPeriodMix";

  export default {
    name      : 'filter-period-sub',
    props:{
      title_class: {type: String, default:'works-filter__block-title'},
      label_class: {type: String, default:''},
    },
    mixins: [FilterPeriodMix],
    data() {
      return {
        cur_from: 0,
        cur_to: 0,
        T_update:null,
        T_create: null,
        is_real_update: true,//чтобы не отправлять запросы, когда меняется конфигурация слайдера
        is_slider_created: false,
        is_period_slider: true,
      }
    },

    methods: {
      on_periodChange: function(y_from, y_to){
        let o_slider=this.$refs.period_range;
        if ( !this.is_slider_created || o_slider.noUiSlider==null ) return;

        if ( y_from===false || y_from==='' || y_from===undefined ) y_from=this.min_from;
        if ( y_to===false || y_to==='' || y_to===undefined ) y_to=this.max_to;

        if ( y_from!=null && y_from==this.cur_from ) return;
        if ( y_to!=null && y_to==this.cur_to ) return;

        this.is_real_update=false;
        o_slider.noUiSlider.set([y_from, y_to]);
        this.is_real_update=true;
      },

      create_slider: function(){
        if ( this.is_slider_created ) return;

        if ( !this.is_show_filter_preiod ){
          clearTimeout( this.T_create );
          this.T_create=setTimeout( ()=>{ this.create_slider() }, 500 );
          return;
        }

        this.is_slider_created=true;
        let this_=this;
        this.$nextTick(()=>{
          let set_from=this_.year_from;
          let set_to=this_.year_to;

          let min_from=this_.min_from;
          let max_to=this_.max_to;
          if ( min_from==max_to ) max_to=min_from+1;

          if ( set_from==null ) set_from=min_from;
          if ( set_to==null ) set_to=max_to;

          let o_slider=this_.$refs.period_range;

          this_.cur_from=set_from;
          this_.cur_to=set_to;
          window.noUiSlider.create(o_slider, {
            start: [parseInt(set_from), parseInt(set_to)],
            connect: true,
            //direction: 'ltr',
            //step: 1,
            format: wNumb({
              decimals: 0
            }),
            range: {
              'min': parseInt(min_from),
              'max': parseInt(max_to),
            }
          });

          o_slider.noUiSlider.on('update', function( values, handle ) {
            this_.cur_from=values[0];
            this_.cur_to=values[1];

            if ( !this_.is_real_update ) return;

            clearTimeout(this.T_update);
            this.T_update=setTimeout( function(){
              let set_from=this_.cur_from;
              let set_to=this_.cur_to;

              if ( set_from<=this_.min_from ) set_from='';
              if ( set_to>=this_.max_to ) set_to='';

              let tmp_from=this_.year_from;
              if ( tmp_from===undefined ) tmp_from='';
              let tmp_to=this_.year_to;
              if ( tmp_to===undefined ) tmp_to='';

              if (tmp_from!=set_from) this_.year_from=set_from;
              if (tmp_to!=set_to) this_.year_to=set_to;

            }, 200 );
          });
        });
      },
    },

    updated() {
      if ( !this.is_slider_created ){
        this.create_slider();
      }
      else {
        this.$nextTick( ()=>{
          let o_slider=this.$refs.period_range;
          if ( o_slider.noUiSlider==null ) return;

          this.is_real_update=false;
          o_slider.noUiSlider.updateOptions({
            range: {
              'min': parseInt(this.min_from),
              'max': parseInt(this.max_to)
            }
          });
          this.is_real_update=true;
        } );
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/filter/FilterPeriodSub.vue